module.exports = __webpack_public_path__ + "img/icon-xmeter.cdd95f85.svg";